export default __webpack_public_path__ + "static/media/logo-dark.7a6a1b02.png";